export default __webpack_public_path__ + "static/media/incisors-tooth.90bac8aa.svg";